import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { queries } from '../../api/queries.js';
import { loadBroker } from '../../features/brokers/selection.js';
import { TAIL_STARTS } from '../../features/tail/start.js';
import { TailPage } from '../../features/tail/TailPage.js';

/**
 * The controls live in the URL, so a tail can be linked to. `run` starts it on arrival — that is
 * how "Tail this stream" and "See it in Tail" hand over — and is dropped from the URL once used.
 * The defaults live here too, so the page reads one settled value per control.
 */
const tailSearch = z.object({
  stream: z.string().optional(),
  filter: z.string().default('>'),
  from: z.enum(TAIL_STARTS).default('last:50'),
  run: z.boolean().optional(),
});

export const Route = createFileRoute('/_app/tail')({
  validateSearch: tailSearch,
  loader: async ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(queries.streams(await loadBroker(queryClient))),
  component: TailPage,
});
